<template>
  <div class="section02" v-if="proData.length >= 1">
    <div class="headersection mt-3">
      <i class="fas fa-usd-circle"></i> โปรโมชั่น
    </div>
    <div class="bccontainer">
      <div class="swiper promotionslide bcsw">
        <swiper
          class="swiper"
          :options="swiperOptions"
          :style="{
            '--swiper-navigation-color': '#b32d18',
            '--swiper-pagination-color': '#b32d18',
          }"
        >
          <swiper-slide
            class="slide"
            v-for="(pt, index) in proData"
            :key="index"
          >
            <div class="d-flex flex-column">
              <p class="text-center" style="font-size: 1rem">{{ pt.name }}</p>
              <img :src="pt.picture" alt="BFCO Promotion" />
              <small
                style="
                  font-size: 1rem;
                  border-bottom: #d5a96f solid;
                  margin-top: 10px;
                  padding-bottom: 5px;
                  align-self: center;
                  width: 205px;
                "
                class="text-center"
                >รายละเอียด</small
              >
              <small
                style="font-size: 1rem; max-width: 400px; align-self: center"
                class="text-center mt-3"
                >{{ pt.detail }}</small
              >
              <div class="text-center mt-3 mb-4">
                <!-- <button
                  class="prosw-button"
                  id="regis"
                  @click="openPromotionModal(pt.id)"
                  v-if="pt.status == '1'"
                >
                  รับโปรโมชั่น
                </button> -->
                <button
                  class="prosw-button"
                  id="regis"
                  @click="openPromotionModal(pt.id)"
                >
                  รับโปรโมชั่น
                </button>
              </div>
            </div>
          </swiper-slide>
          <div
            class="swiper-pagination"
            slot="pagination"
            style="margin-bottom: -5px"
          ></div>
        </swiper>
      </div>
    </div>
    <hr class="x-hr-border-glow my-2 mt-3" />
    <PromotionModal ref="promotionmodal" />
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { HTTP } from "@/services/http-common";
import { mapGetters } from "vuex";
import PromotionModal from "@/components/modal/PromotionModal.vue";

export default {
  name: "promotion-component",
  components: {
    PromotionModal,
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      proData: [],
      step: "",
      swiperOptions: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 20,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
        },
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false,
        // },
        // slidesPerView: 3,
        spaceBetween: 30,
        // loop: true,
        loopFillGroupWithBlank: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          dynamicBullets: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          665: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          425: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          280: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      },
    };
  },
  computed: {
    ...mapGetters(["Auth"]),
  },
  created() {
    this.FetchPromotion();
  },
  methods: {
    // fetchData() {
    //   HTTP.get(`system/promotion`)
    //     .then((resp) => {
    //       this.promotion = resp.data.data;
    //     })
    //     .catch((err) => {
    //       this.$toast.error(
    //         err.data.msg != undefined
    //           ? err.data.msg
    //           : "ไม่สามารถโหลดได้ กรุณาลองใหม่"
    //       );
    //     });
    //},
    fetchUserProfile() {
      HTTP.get(`member/profile`)
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดข้อมูลโปรไฟล์ได้ กรุณาลองใหม่"
            );
          } else {
            if (resp.data.status != undefined && resp.data.status) {
              this.$store.dispatch("saveProfile", resp.data.data);
            }
          }
        })
        .catch((err) => {
          this.$toast.error(
            err.data.msg != undefined
              ? err.data.msg
              : "ไม่สามารถโหลดข้อมูลโปรไฟล์ได้ กรุณาลองใหม่"
          );
        });
    },
    openPromotionModal(id) {
      this.$refs.promotionmodal.show(id);
    },
    FetchPromotion() {
      let loader = this.$loading.show({
        backgroundColor: "#000000",
        color: "#0014AD",
        loader: "spinner",
        width: 64,
        height: 64,
      });
      HTTP.get(`system/promotion`)
        .then((resp) => {
          if (resp.data.status != undefined && !resp.data.status) {
            loader.hide();
            this.$toast.error(
              resp.data.msg != undefined
                ? resp.data.msg
                : "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่"
            );
          } else {
            loader.hide();
            this.proData = resp.data.data;
          }
        })
        .catch((err) => {
          loader.hide();
            this.$toast.error(
              err.data.msg != undefined
                ? err.data.msg
                : "ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่"
            );
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
